import { Button as AntButton, ButtonProps as AntdButtonProps } from 'antd';
import clsx from 'clsx';

type ButtonProps = AntdButtonProps &
    (
        | { label: string; children?: never }
        | { label?: never; children: React.ReactNode }
    );

export function Button({
    label,
    icon,
    className,
    children,
    ...rest
}: ButtonProps) {
    return (
        <AntButton {...rest} className={clsx('rounded-lg', className)}>
            <div className="flex items-center gap-1">
                {icon && <span>{icon}</span>}
                {label && <span className="text-M-16">{label}</span>}
                {children}
            </div>
        </AntButton>
    );
}
